import { Action } from '@ngrx/store';
import { APP_BOOTSTRAP, APP_INIT, APP_POST_LOGIN_PROCESS, APP_UTM_SET, CURRENCY_LOCALE_REFRESH, FORCE_RELOAD } from '../action-types';
import { IAppRouterState } from '../router/router-state';

export class InitAppAction implements Action {
    readonly type = APP_INIT;
}

export class BootstrapAppAction implements Action {
    readonly type = APP_BOOTSTRAP;
}

export class SetAppUTMAction implements Action {
    readonly type = APP_UTM_SET;

    constructor(public payload: any) { }
}

export class ProcessPostLoginAction implements Action {
    readonly type = APP_POST_LOGIN_PROCESS;
}

export class RefreshCurrencyLocale implements Action {
    readonly type = CURRENCY_LOCALE_REFRESH;
    constructor() {}
}

export class ForceReloadAction implements Action {
    readonly type = FORCE_RELOAD;
    constructor(public payload: { state: IAppRouterState }) {}
}